export const Ribbon = [
    { "value": "danger", "label": "alert-danger" },
    { "value": "warning", "label": "alert-warning" },
    { "value": "info", "label": "alert-info" },
    { "value": "success", "label": "alert-success" }
  ];
